<template>
  <div style="width: 100%; height: 100%">
    <div id="Chart4" style="width: 100%; height: calc(100%)"></div>
  </div>
</template>

<script>
export default {
  methods: {
    myEcharts4() {
      var myChart4 = this.$echarts.init(document.getElementById("Chart4"));
      //配置图表
      var option4 = {
        grid: {
          containLabel: true,
          left: -50,
          right: -10,
          bottom: 5,
          top: 15,
        },
        xAxis: {
          type: "category",
          data: [
            "09:30",
            "10:00",
            "10:30",
            "11:00",
            "11:30",
            "12:00",
            "12:30",
            "13:00",
            "13:30",
            "14:00",
            "14:30",
            "15:00",
          ],
          show: true,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: function (index, string) {
              if (index == 0 && string == "09:30") {
                return true;
              } else if (index == 4 && string == "11:30") {
                return true;
              } else if (index == 9 && string == "14:00") {
                return true;
              } else if (index == 11 && string == "15:00") {
                return true;
              } else {
                return false;
              }
            },
            formatter: function (value) {
              if (value == "09:30") {
                return `{a|${value}}`;
              } else {
                return `{b|${value}}`;
              }
            },
            rich: {
              a: {
                width: 66,
                align: "right",
              },
              b: {
                width: 66,
                align: "left",
              },
            },
          },
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "Fake Data",
            symbol: "none",
            sampling: "lttb",
            itemStyle: {
              color: "rgb(255, 70, 131)",
            },
            data: [820, 932, 901, 934, 723, 865, 964, 1123, 654, 258, 789, 888],
            type: "line",
            smooth: true,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(254,141,141,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(255,255,255,1)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
      myChart4.setOption(option4);
    },
  },
  mounted() {
    this.myEcharts4();
  },
};
</script>

<style>
</style>